var marantz_RC027SR = {
    name: "RC027SR",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [21,0,5,207,3,21,3,47,7,39,3,62,7,162,6,211,3,155,6,219,3,0,0,151,198,132],
        },
        {
            function: "KEY_TVAUDIO",
            name: "KEY_TVAUDIO",
            icon: "KEY_TVAUDIO",
            command: [25,0,4,210,3,15,3,54,7,45,3,213,3,151,6,215,3,0,0,222,126,32],
        },
        {
            function: "KEY_CBLSAT",
            name: "KEY_CBLSAT",
            icon: "KEY_CBLSAT",
            command: [23,0,5,211,3,13,3,56,7,40,3,207,3,157,6,57,7,172,6,210,3,0,0,179,31,132],
        },
        {
            function: "KEY_DVD",
            name: "KEY_DVD",
            icon: "KEY_DVD",
            command: [20,0,3,19,3,209,3,165,6,35,7,5,17,195,3,63,212],
        },
        {
            function: "KEY_BLURAY",
            name: "KEY_BLURAY",
            icon: "KEY_BLURAY",
            command: [26,0,3,18,3,210,3,11,17,187,3,18,3,53,7,223,63],
        },
        {
            function: "KEY_AUX1",
            name: "KEY_AUX1",
            icon: "KEY_AUX1",
            command: [22,0,4,16,3,212,3,6,17,195,3,155,6,187,3,28,3,69,7,127,200,128],
        },
        {
            function: "KEY_TUNER",
            name: "KEY_TUNER",
            icon: "KEY_TUNER",
            command: [23,0,5,213,3,14,3,56,7,177,6,35,7,43,3,211,3,145,6,217,3,0,0,166,63,132],
        },
        {
            // function: "KEY_BLUETOOTH",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [20,0,3,23,3,210,3,149,6,43,7,7,17,196,3,61,188],
        },
        {
            function: "KEY_GAME",
            name: "KEY_GAME",
            icon: "KEY_GAME",
            command: [22,0,4,18,3,211,3,6,17,196,3,154,6,197,3,19,3,52,7,126,120,128],
        },
        {
            function: "KEY_AUX2",
            name: "KEY_AUX2",
            icon: "KEY_AUX2",
            command: [24,0,3,20,3,209,3,5,17,197,3,154,6,189,3,127,206],
        },
        {
            function: "KEY_PHONO",
            name: "KEY_PHONO",
            icon: "KEY_PHONO",
            command: [21,0,3,210,3,16,3,40,7,176,6,210,3,0,0,171,249],
        },
        {
            function: "KEY_IPOD_USB",
            name: "KEY_IPOD_USB",
            icon: "KEY_IPOD_USB",
            command: [20,0,5,24,3,211,3,119,20,189,3,20,3,54,7,155,6,35,7,169,6,196,3,124,196,48],
        },
        {
            function: "KEY_MEDIAPLAYER",
            name: "KEY_MEDIAPLAYER",
            icon: "KEY_MEDIAPLAYER",
            command: [23,0,5,216,3,11,3,59,7,41,3,214,3,151,6,41,7,167,6,220,3,0,0,210,63,132],
        },
        {
            function: "KEY_CD",
            name: "KEY_CD",
            icon: "KEY_CD",
            command: [21,0,5,223,3,14,3,50,7,173,6,41,7,46,3,207,3,151,6,218,3,0,0,169,31,132],
        },
        {
            function: "KEY_ONLINEMUSIC",
            name: "KEY_ONLINEMUSIC",
            icon: "KEY_ONLINEMUSIC",
            command: [18,0,4,18,3,219,3,159,6,43,7,14,3,56,7,6,17,190,3,31,53],
        },
        {
            function: "KEY_INTERNETRADIO",
            name: "KEY_INTERNETRADIO",
            icon: "KEY_INTERNETRADIO",
            command: [16,0,5,25,3,54,7,166,6,38,7,29,3,211,3,178,6,194,3,15,17,186,3,13,19,40],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [18,0,3,28,3,205,3,170,6,34,7,16,17,50,7,63,88],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [16,0,3,32,3,205,3,173,6,33,7,16,17,48,7,61,88],
        },
        {
            function: "KEY_SLEEP",
            name: "KEY_SLEEP",
            icon: "KEY_SLEEP",
            command: [21,0,4,214,3,15,3,47,7,40,3,220,3,145,6,57,7,0,0,238,83,16],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [23,0,5,201,3,26,3,51,7,48,3,206,3,160,6,65,7,167,6,178,3,0,0,239,152,132],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [23,0,4,211,3,19,3,48,7,41,3,210,3,154,6,213,3,0,0,239,46,32],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [23,0,4,227,3,3,3,57,7,38,3,225,3,123,6,223,3,0,0,239,44,136],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [20,0,5,33,3,204,3,16,17,187,3,165,6,186,3,26,3,50,7,167,6,28,7,103,24,112],
        },
        {
            // function: "KEY_OPTION",
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [18,0,4,42,3,197,3,167,6,26,7,252,16,209,3,187,6,184,3,45,209,128],
        },
        {
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [18,0,5,39,3,202,3,161,6,28,7,186,6,178,3,17,17,188,3,35,3,50,7,20,195,176],
        },
        {
            function: "KEY_SETUP",
            name: "KEY_SETUP",
            icon: "KEY_SETUP",
            command: [18,0,5,30,3,213,3,149,6,42,7,6,17,199,3,173,6,199,3,22,3,50,7,45,28,48],
        },
        {
            function: "KEY_HOME",
            name: "KEY_HOME",
            icon: "KEY_HOME",
            command: [18,0,3,38,3,200,3,169,6,27,7,143,13,207,3,45,244],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [20,0,4,25,3,209,3,178,6,174,3,36,3,48,7,9,17,191,3,18,159,160],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [22,0,4,25,3,207,3,45,3,47,7,1,17,194,3,172,6,179,3,47,248,128],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [18,0,5,33,3,202,3,177,6,30,7,253,16,199,3,42,3,60,7,169,6,171,3,34,190,16],
        },
        {
            function: "KEY_PREVIOUS",
            name: "KEY_PREVIOUS",
            icon: "KEY_PREVIOUS",
            command: [20,0,4,31,3,203,3,2,17,63,7,169,6,26,7,167,6,180,3,121,241],
        },
        {
            function: "KEY_NEXT",
            name: "KEY_NEXT",
            icon: "KEY_NEXT",
            command: [22,0,3,32,3,198,3,255,16,55,7,171,6,180,3,127,228],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [20,0,5,32,3,204,3,42,3,47,7,3,17,195,3,169,6,26,7,172,6,179,3,44,126,16],
        },
        {
            function: "KEY_FASTFORWARD",
            name: "KEY_FASTFORWARD",
            icon: "KEY_FASTFORWARD",
            command: [20,0,5,33,3,199,3,40,3,63,7,173,6,27,7,7,17,191,3,174,6,170,3,20,254,16],
        },
        {
            function: "KEY_SMARTSELECT1",
            name: "KEY_SMARTSELECT1",
            icon: "KEY_SMARTSELECT1",
            command: [18,0,4,39,3,195,3,175,6,26,7,247,16,211,3,188,6,168,3,61,168,128],
        },
        {
            function: "KEY_SMARTSELECT2",
            name: "KEY_SMARTSELECT2",
            icon: "KEY_SMARTSELECT2",
            command: [18,0,5,37,3,197,3,169,6,26,7,247,16,208,3,189,6,170,3,43,3,60,7,61,162,16],
        },
        {
            function: "KEY_SMARTSELECT3",
            name: "KEY_SMARTSELECT3",
            icon: "KEY_SMARTSELECT3",
            command: [20,0,4,36,3,197,3,167,6,29,7,253,16,204,3,188,6,175,3,61,163,128],
        },
        {
            function: "KEY_SMARTSELECT4",
            name: "KEY_SMARTSELECT4",
            icon: "KEY_SMARTSELECT4",
            command: [20,0,5,33,3,201,3,244,16,212,3,171,6,25,7,171,6,173,3,45,3,54,7,121,136,112],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [16,0,5,43,3,198,3,179,6,28,7,188,6,179,3,113,20,55,7,27,3,53,7,26,152,72],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [16,0,5,34,3,199,3,178,6,27,7,182,6,184,3,120,20,57,7,34,3,51,7,26,97,72],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [20,0,3,22,3,211,3,153,6,39,7,6,17,197,3,63,180],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [21,0,4,198,3,34,3,42,7,48,3,195,3,172,6,27,7,0,0,238,89,16],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [21,0,5,198,3,32,3,28,7,54,3,200,3,169,6,51,7,186,6,179,3,0,0,139,47,33],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [21,0,4,202,3,27,3,42,7,50,3,211,3,169,6,26,7,0,0,236,185,16],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [23,0,4,208,3,23,3,49,7,41,3,208,3,154,6,211,3,0,0,236,185,136],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [21,0,4,210,3,20,3,45,7,44,3,211,3,154,6,211,3,0,0,236,178,136],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [19,0,5,214,3,23,3,48,7,170,6,42,7,44,3,208,3,155,6,197,3,0,0,166,38,40,64],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [21,0,4,208,3,23,3,45,7,41,3,210,3,154,6,49,7,0,0,236,179,16],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [21,0,5,197,3,29,3,27,7,51,3,204,3,170,6,47,7,189,6,205,3,0,0,139,44,225],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [19,0,5,211,3,20,3,38,7,46,3,209,3,154,6,62,7,175,6,209,3,0,0,139,41,97],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [19,0,5,27,7,52,3,197,3,170,6,202,3,35,3,47,7,188,6,180,3,0,0,35,45,161],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [21,0,5,210,3,21,3,41,7,41,3,56,7,180,6,213,3,148,6,207,3,0,0,150,47,132],
        },
        {
            function: "KEY_ENTER",
            name: "KEY_ENTER",
            icon: "KEY_ENTER",
            command: [21,0,5,205,3,19,3,48,7,173,6,52,7,46,3,212,3,157,6,206,3,0,0,103,139,132],
        },
    ]
}
export default marantz_RC027SR